import { commonUtils } from '@/helpers/commonUtils'
import styles from './FreeTrialPageMobile.module.less'
import ApplyTrialBoxMobile, { ApplyTrialParam } from './ApplyTrialBoxMobile/ApplyTrialBoxMobile'
import { api } from '@/api'
import { message } from 'antd'
import { useEffect, useState } from 'react'
import AButton from '@/components/A/AButton/AButton'
import cls from 'classnames'
import { useNavigate } from 'react-router-dom'
import { PAGE_LINKS } from '@/router/pageConst'
import { useTranslation } from 'react-i18next'
import { corpService } from '@/services/corpService'

interface Props {
  userInfo?: Models.UserInfo
  forStatus?: boolean
}
function FreeTrialPageMobile({ userInfo, forStatus }: Props) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const platformType = commonUtils.getMobilePlatformType()
  const [mode, setMode] = useState<'apply' | 'done'>('apply')
  const onSubmit = async (param: ApplyTrialParam) => {
    try {
      await api.corp.applyForFreeTrial(param).send()
      corpService.refreshFreeTrialStatus(undefined, { force: true })
      message.success(t('modals.freeTrialModal.message.submitSuccess'))
      setMode('done')
    } catch (e: any) {
      const error = e as ApiError
      // console.error(error.statusMessage)
      // message.error(t('modals.freeTrialModal.message.submitFailed'))
      message.error(error.statusMessage)
    }
  }

  useEffect(() => {
    if (forStatus) {
      setMode('done')
    }
  }, [forStatus])

  return <div className={styles.freeTrialPage} data-testid='free-trial-page'>
    <div className={cls(styles.freeTrialPageContent, platformType === 'ios' && styles.ios)}>
      <img className={styles.bg} src={commonUtils.getImagePath('pricingPageMobile/pricing-page-bg.png')} alt="" />
      {mode === 'apply' && userInfo && (
        <div className={cls(styles.card, styles.apply)}>
          <p className={styles.title}>{t('modals.freeTrialModal.title')}</p>
          <ApplyTrialBoxMobile userInfo={userInfo} onSubmit={onSubmit} />
        </div>
      )}
      {mode === 'done' && (
        <div className={cls(styles.card, styles.done)}>
          <img
            className={styles.brand}
            src={commonUtils.getImagePath('loginPage/login-brand.png')}
            alt=''
          />
          <img className={styles.gift} src={commonUtils.getImagePath('common/gift-icon.png')} alt="" />
          <p className={styles.title}>{t('modals.freeTrialModal.gotTrial')}</p>
          <p className={styles.desc}>{t('modals.freeTrialModal.goPc')}</p>
          <AButton testId='free-trial-mobile-back-home-btn' className={styles.btn} type='outlined' size='LGR' onClick={() => {
            navigate(PAGE_LINKS.index)
          }}>
            <span className={styles.btnText}>{t('modals.freeTrialModal.back')}</span>
            <img className={styles.btnIcon} src={commonUtils.getImagePath('homePage/right-arrow-icon-black.png')} alt='' />
          </AButton>
        </div>
      )}
    </div>
  </div>
}

export default FreeTrialPageMobile
